import React, { useState } from "react";
import "../../css/CRUDModal.css";
import { apiList } from "../../helpers/apiList";
import { axiosPostApi } from "../../helpers/interceptorServices";
import CustomAlert from "../../helpers/CustomAlert";
import LeftCircle from "../../assets/Icons/Left circle B.png";
import RightCircle from "../../assets/Icons/Right circle A.png";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import CrossIcon from "../../assets/Icons/cross_svg.svg";

const SelectToNotifyModal = ({
  show,
  handleClose,
  columnData,
  franchiseData,
  callApi,
}) => {
  const loggedInUserName = sessionStorage.getItem("username");
  const [loading, setLoading] = useState(false);

  const handleBack = () => {
    handleClose();
  };

  //   useEffect(() => {
  //     fetchNotificationData();
  //   }, []);

  //   const fetchNotificationData = async () => {
  //     setLoading(true);
  //     try {
  //       const payload = {
  //         username: loggedInUserName,
  //         notificationId: columnData?.notificationId || "",
  //       };

  //       const response = await axiosPostApi(
  //         apiList.FETCH_NOTIFICATION_MASTER,
  //         payload
  //       );
  //       if (
  //         response?.data?.status === true &&
  //         response?.data?.respCode === "00"
  //       ) {
  //         setLoading(false);
  //         //   const modifiedData = modifyStructure(response?.data?.data);
  //         setData(response?.data?.data);
  //         if (response?.data?.data?.length === 0) {
  //           setNoData(true);
  //         } else {
  //           setNoData(false);
  //         }
  //       } else {
  //         setLoading(false);
  //         setNoData(true);
  //         setData([]);
  //       }
  //     } catch (error) {
  //       setLoading(false);
  //       CustomAlert({
  //         title: "Error",
  //         text: "An error occurred while fetching the data. Please try again later.",
  //         icon: "error",
  //         confirmButtonText: "Retry",
  //       });
  //     } finally {
  //       setLoading(false);
  //     }
  //   };

  const handleSendtoNotify = async (row) => {
    setLoading(true);

    try {
      const payload = {
        username: loggedInUserName,
        bagNo: columnData?.bagNo || "",
      };

      const response = await axiosPostApi(apiList.SEND_TO_HUB, payload);
      if (
        response?.data?.status === true &&
        response?.data?.respCode === "00"
      ) {
        CustomAlert({
          title: "Success",
          text:
            response?.data?.message ||
            "The bag has been successfully sent to the courier hub.",
          icon: "success",
          confirmButtonText: "Okay",
        });
        callApi();
        handleClose();
      } else {
        CustomAlert({
          title: "Failed",
          text: response?.data?.message || "Failed to fetch data",
          icon: "error",
          confirmButtonText: "Retry",
        });
      }
    } catch (error) {
      CustomAlert({
        title: "Error",
        text: "An error occurred while fetching the data. Please try again later.",
        icon: "error",
        confirmButtonText: "Retry",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {show && (
        <div
          style={{
            position: "fixed",
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            backgroundColor: "rgba(0,0,0,0.4)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1060,
          }}
        >
          <div className="modal-dialog" role="document">
            <div
              className="modal-content"
              style={{
                width: "550px",
                borderRadius: "20px",
                padding: "28px",
                backgroundColor: "#ffffff",
                border: "1px solid #e5e7eb",
                boxShadow: "0 8px 40px rgba(0,0,0,0.12)",
                position: "relative",
              }}
            >
              <img
                src={LeftCircle}
                alt="leftImg"
                className="absolute left-0 bottom-0 w-[110px] h-[105px]"
              />
              <img
                src={RightCircle}
                alt="leftImg"
                className="absolute right-0 top-0 w-[110px] h-[105px]"
              />
              <div
                className="modal-header flex items-center justify-between pb-2"
                style={{
                  borderBottom: "1px solid #dee2e6",
                }}
              >
                <div className="flex items-center gap-2">
                  <NotificationsActiveIcon
                    style={{ color: "#ff7a00", fontSize: "26px" }} // bright modern orange
                  />
                  <h5 className="modal-title main-title font-medium">
                    Send Notification
                  </h5>
                </div>
                <img
                  src={CrossIcon}
                  alt="filter icon"
                  className="w-[30px] h-[30px] cursor-pointer z-20"
                  onClick={handleBack}
                />
              </div>
              <form>
                <div
                  className="scoped-modal modal-body"
                  style={{
                    display: "flex",
                    // justifyContent: "center",
                    gap: "24px",
                  }}
                >
                  <div className="flex gap-4 mt-4 mb-4 mx-auto">
                    <label
                      className="flex items-center gap-3 cursor-pointer p-3 border rounded-lg hover:bg-gray-100 transition"
                      style={{
                        borderColor: "#4f46e5",
                        background: "#f5f5ff",
                      }}
                    >
                      <span className="font-medium text-gray-700 text-[16px]">
                        Send To Destination
                      </span>
                    </label>
                  </div>

                  {/* commented code for future development */}
                  {/* {loading ? (
                    <CircularProgress className="circular-loader" />
                  ) : data && data?.length > 0 ? (
                    <div className="table-container" style={{ width: "100%" }}>
                      <div className="table-wrapper">
                        <table className="custom-table">
                          <thead>
                            <tr>
                              <th>Bag No</th>
                              <th style={{ textAlign: "center" }}>Bag ID</th>
                              <th>Created By</th>
                              <th>Created Date</th>
                              <th>Notification Id</th>
                              <th>Remark</th>
                            </tr>
                          </thead>
                          <tbody>
                            {data?.map((item, index) => (
                              <tr key={index}>
                                <td>{item.bagNo || "-"}</td>
                                <td style={{ textAlign: "center" }}>
                                  {item.bagId || "-"}
                                </td>
                                <td>{item.createdBy || "-"}</td>
                                <td>{item.createdDate || "-"}</td>
                                <td>{item.notificationId || "-"}</td>
                                <td title={item.remarks || "-"}>
                                  {truncateRemark(item.remarks) || "-"}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  ) : (
                    <div
                      style={{
                        textAlign: "center",
                        padding: "20px",
                        color: "#888",
                        fontStyle: "italic",
                      }}
                    >
                      No details available.
                    </div>
                  )} */}
                </div>

                <div
                  className="scoped-modal"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    padding: "12px",
                    paddingBottom: "0px",
                    gap: "16px",
                    borderTop: "1px solid #dee2e6",
                  }}
                >
                  <button
                    type="button"
                    className="btn btn-back !rounded-lg"
                    onClick={handleBack}
                  >
                    Cancel
                  </button>

                  <button
                    type="button"
                    className="btn btn-submit !rounded-lg"
                    onClick={handleSendtoNotify}
                    disabled={loading}
                  >
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default SelectToNotifyModal;
